import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  Grid,
} from '@mui/material';
import Alert from '@mui/material/Alert';

const OmitHotelDialog = ({
  open,
  onClose,
  hotelName,
  isLoading,
  isShowAlert,
  alertOptions,
  onOmit,
  onAlertClose,
}) => (
  <Dialog open={open} onClose={onClose} disableRestoreFocus>
    <DialogTitle>Omitir hotel</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {isLoading ? (
          <Grid style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress color="primary" />
          </Grid>
        ) : isShowAlert ? (
          <Alert severity={alertOptions.type}>{alertOptions.msg}</Alert>
        ) : (
          <>
            <Typography variant="body1" component="span">
              ¿Está seguro que desea omitir el hotel{' '}
              <span style={{ textTransform: 'capitalize' }}>
                &quot;{String(hotelName)?.toLowerCase()}&quot;?
              </span>
            </Typography>
            <Typography variant="body1" component="span">
              {' '}
              ¡En futuras búsquedas no aparecerá!
            </Typography>
          </>
        )}
      </DialogContentText>
    </DialogContent>
    {!isLoading && (
      <DialogActions>
        {isShowAlert ? (
          <Button
            onClick={onAlertClose}
            variant="contained"
            style={{ backgroundColor: 'green', color: 'white' }}
          >
            Aceptar
          </Button>
        ) : (
          <>
            <Button
              onClick={onClose}
              variant="contained"
              style={{ backgroundColor: 'red', color: 'white' }}
            >
              Cancelar
            </Button>
            <Button
              onClick={onOmit}
              variant="contained"
              style={{ backgroundColor: 'green', color: 'white' }}
            >
              Omitir
            </Button>
          </>
        )}
      </DialogActions>
    )}
  </Dialog>
);

export default OmitHotelDialog;
